import { Rule } from './Rule';

export class FalseRule extends Rule {
  get isTriggered(): boolean {
    return false;
  }
}
